export default __webpack_public_path__ + "static/media/LaptopScreen.fb8076ca.png";